import './movie-card.scss';
